var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "guardian-component" },
    [
      _vm.firstname
        ? _c("card-title-component", {
            attrs: { title: _vm.firstname + " " + _vm.lastname }
          })
        : _c("card-title-component", { attrs: { title: _vm.email } }),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _vm._v(
                "\n                " + _vm._s(_vm.index2) + "\n                "
              ),
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "firstname-form-group",
                    label: _vm.$t("guardian.firstname"),
                    "label-for": "firstname-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "firstname-input",
                      type: "text",
                      required: "",
                      placeholder: _vm.$t("guardian.firstname"),
                      disabled: ""
                    },
                    model: {
                      value: _vm.firstname,
                      callback: function($$v) {
                        _vm.firstname = $$v
                      },
                      expression: "firstname"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "lastname-form-group",
                    label: _vm.$t("guardian.lastname"),
                    "label-for": "lastname-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "lastname-input",
                      type: "text",
                      required: "",
                      placeholder: _vm.$t("guardian.lastname"),
                      disabled: ""
                    },
                    model: {
                      value: _vm.lastname,
                      callback: function($$v) {
                        _vm.lastname = $$v
                      },
                      expression: "lastname"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "address-form-group",
                    label: _vm.$t("guardian.address"),
                    "label-for": "address-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "address-input",
                      type: "text",
                      required: "",
                      placeholder: _vm.$t("guardian.address"),
                      disabled: ""
                    },
                    model: {
                      value: _vm.address,
                      callback: function($$v) {
                        _vm.address = $$v
                      },
                      expression: "address"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "address-extra-line-form-group",
                    label: _vm.$t("guardian.addressExtraInformation"),
                    "label-for": "address-extra-line-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "address-extra-line-input",
                      type: "text",
                      required: "",
                      placeholder: _vm.$t("guardian.addressExtraInformation"),
                      disabled: ""
                    },
                    model: {
                      value: _vm.extraAddressLine,
                      callback: function($$v) {
                        _vm.extraAddressLine = $$v
                      },
                      expression: "extraAddressLine"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "zipcode-form-group",
                    label: _vm.$t("guardian.zipcode"),
                    "label-for": "zipcode-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "firstname-input",
                      type: "text",
                      required: "",
                      placeholder: _vm.$t("guardian.zipcode"),
                      disabled: ""
                    },
                    model: {
                      value: _vm.zipcode,
                      callback: function($$v) {
                        _vm.zipcode = $$v
                      },
                      expression: "zipcode"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "lastname-form-group",
                    label: _vm.$t("guardian.city"),
                    "label-for": "city-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "city-input",
                      type: "text",
                      required: "",
                      placeholder: _vm.$t("guardian.city"),
                      disabled: ""
                    },
                    model: {
                      value: _vm.city,
                      callback: function($$v) {
                        _vm.city = $$v
                      },
                      expression: "city"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "email-form-group",
                    label: _vm.$t("guardian.email"),
                    "label-for": "email-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "email-input",
                      type: "text",
                      required: "",
                      placeholder: _vm.$t("guardian.email"),
                      disabled: ""
                    },
                    model: {
                      value: _vm.email,
                      callback: function($$v) {
                        _vm.email = $$v
                      },
                      expression: "email"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "mobile-form-group",
                    label: _vm.$t("guardian.mobile"),
                    "label-for": "mobile-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "mobile-input",
                      type: "text",
                      required: "",
                      placeholder: _vm.$t("guardian.mobile"),
                      disabled: ""
                    },
                    model: {
                      value: _vm.mobile,
                      callback: function($$v) {
                        _vm.mobile = $$v
                      },
                      expression: "mobile"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "phone-form-group",
                    label: _vm.$t("guardian.phone"),
                    "label-for": "phone-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "phone-input",
                      type: "text",
                      required: "",
                      placeholder: _vm.$t("guardian.phone"),
                      disabled: ""
                    },
                    model: {
                      value: _vm.phone,
                      callback: function($$v) {
                        _vm.phone = $$v
                      },
                      expression: "phone"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col" },
            [
              _c(
                "b-form-group",
                {
                  staticClass: "o-label",
                  attrs: {
                    id: "website-form-group",
                    label: _vm.$t("guardian.website"),
                    "label-for": "website-input"
                  }
                },
                [
                  _c("b-form-input", {
                    staticClass: "o-form",
                    attrs: {
                      id: "website-input",
                      type: "text",
                      required: "",
                      placeholder: _vm.$t("guardian.website"),
                      disabled: ""
                    },
                    model: {
                      value: _vm.website,
                      callback: function($$v) {
                        _vm.website = $$v
                      },
                      expression: "website"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f5854f44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5854f44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/guardian/GuardianComponent.vue
// module id = null
// module chunks = 